import Client from '../axiosClient'
const resource = '/property';
const resourcePropPartner = '/propertyByPartner';

const resourceInit = '/property_initialize';
// const resourcePropertyInit = '/partner_property_initialize';
const resourceUpdateStatus = '/property_change_status';
const resourceDelete = '/property_delete';
const resourceCountry = '/filter/country'
const resourceUpdateDate = '/updateCloseDays'
const GEO_DATA_BY_LAT_LNG = '/getGeoDataByLatLng'

export default {
  updateCloseDays(payload){
    return Client.post(`${resourceUpdateDate}`, payload);
  },

  init(tab=0,id=null) {
    let filterParam = 'tabIndex='+tab;
    return Client.get(`${resourceInit}?${filterParam}&id=${id}`);
  },

  initPropPartner(tab=0,id=null) {
    let filterParam = 'tabIndex='+tab;
    return Client.get(`${resourceInit}?${filterParam}&id=${id}`);
  },


  get(payload) {
    if(payload) { 
      // console.log("filterParam",payload);
      let filterParam = `{"lat":"${payload['geoLocation'].lat}","lng":"${payload['geoLocation'].lng}","name":"${payload['geoLocation'].name}"}`;
      let partnerId = payload['partnerId'] != undefined ? payload['partnerId'] : "0";
      let partnerUserId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
      return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}&geoLocation=${filterParam}&dashPartnerId=${partnerUserId}&partnerId=${partnerId}`);
    }
    return Client.get(`${resource}`);
  },


  // get(payload) {
  //   if(payload) {
  //     return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
  //   }
  //   return Client.get(`${resource}`);
  // },

  // getDataWithFilter(payload) {
  //   return Client.post(`filter${resource}`, payload);
  // },


 


  getDataWithFilterByPartner (payload) {
    return Client.post(`filter${resourcePropPartner}`, payload);
  },

  getDataWithFilter (payload) {
    return Client.post(`filter${resource}`, payload);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  getCountry() {
    return Client.get(`${resourceCountry}`)
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },
  delete(payload) {
    return Client.post(`${resourceDelete}`, payload);
  },
  
  getGeoData(payload) {
    return Client.post(`${GEO_DATA_BY_LAT_LNG}`, payload);
  },
  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/travel/propertyRepository.js